export const SOURCE_SCRIPT_FACT_LABELS = {
    scriptCategory: 'Script category',
    estimatedLinesOfCode: 'Estimated lines of code',
    complexity: 'Migration complexity',
    overallTier: 'Overall complexity tier',
    effortBand: 'Effort band',
    migrationScore: 'Migration complexity score',
    migrationTier: 'Migration complexity tier',
    codeScore: 'Code complexity score',
    codeTier: 'Code complexity tier',
    migrationComplexityScore: 'Migration complexity score',
    migrationComplexityTier: 'Migration complexity tier',
    codeComplexityScore: 'Code complexity score',
    codeComplexityTier: 'Code complexity tier',
    scale: 'Score scale',
    drivers: 'Complexity drivers',
    logicProfile: 'Code structure counts',
    dynamicSql: 'Dynamic SQL',
    dynamicSqlKinds: 'Dynamic SQL by kind',
    places: 'Places',
    kinds: 'By kind',
    literal: 'Fixed text',
    variable: 'One statement with parts',
    built: 'Assembled while running',
    dependencyCount: 'Objects referenced',
    joins: 'Joins',
    joinType: 'Join type',
    leftTable: 'Left table',
    rightTable: 'Right table',
    ghostCodeFlag: 'Flagged as ghost code',
    notes: 'Notes',
    name: 'Name',
    count: 'Count',
    risk: 'Risk',
    caseExpressions: 'CASE expressions',
    maxCaseBranches: 'Most branches in one CASE',
    totalCaseBranches: 'CASE branches',
    conditionals: 'Conditionals',
    windowFunctions: 'Window functions',
    aggregateFunctions: 'Aggregate functions',
    arithmeticExpressions: 'Arithmetic expressions',
    castOperations: 'CAST operations',
    extractCalls: 'EXTRACT calls',
    coalesceExpressions: 'COALESCE expressions',
    betweenExpressions: 'BETWEEN expressions',
    inExpressions: 'IN expressions',
    likeExpressions: 'LIKE expressions',
    booleanOperators: 'Boolean operators',
    subqueries: 'Subqueries',
    maxNestingDepth: 'Deepest nesting level',
    groupByColumns: 'GROUP BY columns',
    havingClauses: 'HAVING clauses',
    orderByClauses: 'ORDER BY clauses',
    whereClauses: 'WHERE predicates',
    distinctScalarFuncs: 'Scalar functions used',
    distinctAggregates: 'Aggregate functions used',
    distinctWindowFuncs: 'Window functions used',
    functionCalls: 'Function calls',
    loops: 'Loops',
    cursors: 'Cursors',
    joinCount: 'Joins',
    cteCount: 'CTEs',
    unionCount: 'UNIONs',
    statementTypes: 'Statements by type',
    joinTypes: 'Joins by type',
    conventionalBreakdown: 'Conventional constructs by kind',
    simpleBreakdown: 'Simple constructs by kind',
    selfJoinCount: 'Self-joins',
    lateralJoinCount: 'Lateral joins',
    recursiveCteCount: 'Recursive CTEs',
    intersectExceptCount: 'INTERSECT / EXCEPT',
    rollupCount: 'ROLLUP clauses',
    cubeCount: 'CUBE clauses',
    groupingSetsCount: 'GROUPING SETS clauses',
    qualifyCount: 'QUALIFY clauses',
    nullifExpressions: 'NULLIF expressions',
    pivotCount: 'PIVOT clauses',
    unpivotCount: 'UNPIVOT clauses',
    connectByCount: 'CONNECT BY clauses',
    mergeCount: 'MERGE statements',
    errorHandlingCount: 'Error handling blocks',
    declareCount: 'Variables declared',
    transactionCount: 'Transactions',
    functionTypeCounts: 'Functions by type',
    totalStatements: 'Statements',
    simpleStatementCount: 'Simple statements',
    conventionalStatementCount: 'Conventional statements',
    correlatedSubqueryCount: 'Correlated subqueries',
    teradataMetrics: 'Teradata-specific counts',
    collectStatisticsCount: 'COLLECT STATISTICS statements',
    volatileTableCount: 'VOLATILE tables',
    multisetTableCount: 'MULTISET tables',
    setTableCount: 'SET tables',
    primaryIndexCount: 'PRIMARY INDEX definitions',
    partitionCount: 'Partitions',
    bteqCommandCount: 'BTEQ commands',
    macroCount: 'Macros',
    fastloadMloadCount: 'FastLoad / MultiLoad / TPT steps',
    scriptType: 'Script type',
};
export const SOURCE_SCRIPT_GAP_LABELS = {
    FACT_LIST_TRUNCATED: 'Some recorded facts were left out (list limit)',
    SCRIPT_TRUNCATED: 'Only the first part of the script was included',
    TABLE_ROLES_UNRECORDED: 'Which tables are read and which are written is not recorded',
    LINEAGE_TABLE_LEVEL: 'Data flow is recorded per table, not per column',
    COMPLEXITY_UNSCORED: 'No complexity score is recorded',
    DYNAMIC_SQL_UNREADABLE: 'SQL built while the script runs cannot be read from the file',
    DEPENDENCY_LOOKUP_LIMIT: 'Not every called script was looked up',
    DEPENDENCY_NOT_IN_INVENTORY: "A called script is not in this Program's script list",
    DEPENDENCY_AMBIGUOUS: 'A called script matches more than one script',
    DEPENDENCY_BODY_OMITTED: "A called script's code was not included",
    DEPENDENCY_SOURCE_UNAVAILABLE: "A called script's code is unavailable",
};
const CONTEXT_PATH_LABELS = {
    archerFacts: "Archer's analysis",
    'dependencies.tables': 'Tables read and written',
    'dependencies.tables.reads': 'Tables read',
    'dependencies.tables.writes': 'Tables written',
    'dependencies.calledScripts': 'Called scripts',
    'script.numberedContent': "the script's code",
    'script.complete': 'whether the whole script was included',
    'script.includedLines': 'lines included',
    'script.lineCount': 'total lines',
    provenance: 'where each part comes from',
    'provenance.archerAnalysis': "Archer's analysis",
    'provenance.sourceTextOnly': 'the source text',
};
const own = (map, key) => Object.prototype.hasOwnProperty.call(map, key);
const lookup = (map, key) => own(map, key) ? map[key] ?? null : null;
const CAMEL_CASE = /^[a-z][a-z0-9]*[A-Z][A-Za-z0-9]*$/;
const IDENTIFIER_KEY = /^[a-z][A-Za-z0-9]*$/;
export function sourceScriptFactLabel(key) {
    const known = lookup(SOURCE_SCRIPT_FACT_LABELS, key);
    if (known)
        return known;
    if (!IDENTIFIER_KEY.test(key))
        return key;
    const words = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
}
export function labelSourceScriptFacts(value) {
    if (Array.isArray(value))
        return value.map(labelSourceScriptFacts);
    if (!value || typeof value !== 'object')
        return value;
    return Object.fromEntries(Object.entries(value)
        .map(([key, item]) => [sourceScriptFactLabel(key), labelSourceScriptFacts(item)]));
}
const GAP_CODES = Object.keys(SOURCE_SCRIPT_GAP_LABELS).join('|');
const isCamelFactKey = (token) => CAMEL_CASE.test(token) && own(SOURCE_SCRIPT_FACT_LABELS, token);
function pathLabel(path) {
    const clean = path.replace(/^sourceScriptContext\./, '').replace(/\[\]/g, '');
    if (clean.startsWith('gaps.'))
        return lookup(SOURCE_SCRIPT_GAP_LABELS, clean.slice(5));
    const exact = lookup(CONTEXT_PATH_LABELS, clean);
    if (exact)
        return exact;
    const segments = clean.split('.');
    if (segments[0] === 'archerFacts')
        return sourceScriptFactLabel(segments[segments.length - 1] ?? clean);
    return lookup(CONTEXT_PATH_LABELS, segments.slice(0, 2).join('.'))
        ?? (segments[0] === 'provenance' ? lookup(CONTEXT_PATH_LABELS, 'provenance') : null);
}
const PATH = String.raw `(?:sourceScriptContext\.)?(?:archerFacts(?:\.[A-Za-z]\w*)*|gaps\.(?:${GAP_CODES})|provenance(?:\.[A-Za-z]\w*)+|dependencies\.(?:tables|calledScripts)(?:\[\])?(?:\.[A-Za-z]\w*)*|script\.(?:numberedContent|complete|includedLines|lineCount))`;
const PATH_EXACT = new RegExp(`^${PATH}$`);
const PROSE_TOKEN = new RegExp(String.raw `(?<![\w.\]\[@#$])(?:${PATH}|${GAP_CODES}|[a-z][a-z0-9]*[A-Z][A-Za-z0-9]*)(?![\w\[])`, 'g');
function internalTokenLabel(token) {
    if (PATH_EXACT.test(token))
        return pathLabel(token);
    return lookup(SOURCE_SCRIPT_GAP_LABELS, token) ?? (isCamelFactKey(token) ? lookup(SOURCE_SCRIPT_FACT_LABELS, token) : null);
}
function cleanProse(text) {
    return text.replace(PROSE_TOKEN, token => internalTokenLabel(token) ?? token);
}
function cleanLine(line) {
    return line.split(/(`+[^`]*`+)/).map(part => {
        const code = /^(`+)([^`]*)\1$/.exec(part);
        if (!code)
            return cleanProse(part);
        return internalTokenLabel((code[2] ?? '').trim()) ?? part;
    }).join('');
}
export function plainSourceScriptAnswer(text) {
    let inFence = false;
    return text.split('\n').map(line => {
        if (/^\s{0,3}(```|~~~)/.test(line)) {
            inFence = !inFence;
            return line;
        }
        return inFence ? line : cleanLine(line);
    }).join('\n');
}
//# sourceMappingURL=sourceScriptFactLabels.js.map